function BrandMark({ inverse = false, compact = false }) {
    const sizeClass = compact ? 'h-10 w-auto' : 'h-10 w-auto lg:h-12'
    const footerTreatment = inverse
        ? 'rounded-md bg-white px-2 py-1 shadow-[0_8px_24px_rgba(0,0,0,0.2)]'
        : ''

    return (
        <div className={`inline-flex items-center ${footerTreatment}`.trim()}>
            <img
                src="/assets/Main Logo.png"
                alt="Open Letter Marketing"
                className={sizeClass}
            />
        </div>
    )
}

export default BrandMark
